module.exports = __webpack_public_path__ + "img/diners.cca4a6ab.svg";